// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"c3e1cd73","122":"5527cb98","218":"9315230c","775":"9270534f","787":"c23405d5","875":"d645235d","989":"85cb5e45"}[chunkId] + ".chunk.js";
};